import { render, staticRenderFns } from "./SelectableCardContent.vue?vue&type=template&id=b884c132&functional=true&"
import script from "./SelectableCardContent.vue?vue&type=script&lang=ts&"
export * from "./SelectableCardContent.vue?vue&type=script&lang=ts&"
import style0 from "./SelectableCardContent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports